<div
  [hidden]="!selected"
  class="email-node-menu flow-menu"
  (click)="$event.stopPropagation()"
  #nodeMenuElement
>
  
  <div class="integration">
    <lhpe-select
      controlName="integration"
      placeholder="Integration"
      [formGroup]="emailNodeForm!"
      [required]="true"
      [options]="integrationOptions"
      displayValue="name"
      optionValue="id"
      [optionIsSelf]="true"
    >
    </lhpe-select>
  </div>

  <div class="template">
    <lhpe-select
      controlName="template"
      placeholder="Template"
      [formGroup]="emailNodeForm!"
      [required]="true"
      [options]="templateOptions"
      displayValue="name"
      optionValue="id"
      [optionIsSelf]="true"
    >
    </lhpe-select>
  </div>

  <div class="frequency">
    <lhpe-select
      controlName="frequency"
      placeholder="Frequency"
      [formGroup]="emailNodeForm!"
      [options]="emailFrequencies"
      displayValue="label"
      optionValue="value"
      [required]="true"
    >
    </lhpe-select>
  </div>

  <div class="subject">
    <lhpe-input
        class="input"
        controlName="subject"
        placeholder="Subject"
        [formGroup]="emailNodeForm!"
        [required]="true"
        type="string"
      >
      </lhpe-input>
  </div>

  <div class="payload content-box">
    Payload
    <div *ngFor="let property of payloadProperties" class="payload-row">
        <lhpe-input
              class="property-key"
              [control]="property.keyControl"
              placeholder="Enter Key Name"
            >
        </lhpe-input>
        <lhpe-input
          class="property-value"
          [control]="property.valueControl"
          [placeholder]="property.keyNamePrefix + ' Key Value'"
        >
        </lhpe-input>
        <button
          *ngIf="property.completed"
          mat-button
          color="warn"
          (click)="removePayloadProperty(property)"
        >
          <svg-icon
            src="assets/svg/trashcan.svg"
            [svgStyle]="{
              'width.px': '22.5',
              'height.px': '22.298'
            }"
            svgClass="white"
          ></svg-icon>
        </button>

        <button
          *ngIf="!property.completed"
          mat-button
          color="lightGreen"
          [disabled]="
            property.keyControl.invalid || property.valueControl.invalid
          "
          (click)="addPayloadProperty(property)"
        >
          ADD
        </button>
    </div>
  </div>

  <div class="sample_payload">
    Sample Payload<br>
    <pre>{{payloadPreview | json}}</pre>
  </div>

</div>
